export default __webpack_public_path__ + "static/media/ic_wmatic_24.eae0aada.svg";